module.exports = __webpack_public_path__ + "static/media/logo.d44594c0.svg";